var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarWithDot = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 17.972h17.972V0H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.486 15.976h-13a.49.49 0 0 1-.49-.49v-8.5h13.98v8.5a.49.49 0 0 1-.49.49m-13-12.98h1.5v1.99h1v-1.99h8v1.99h1v-1.99h1.5c.27 0 .489.22.49.49v2.5H1.996v-2.5a.492.492 0 0 1 .49-.49m13-1.02h-1.5v-.99h-1v.99h-8v-.99h-1v.99h-1.5a1.51 1.51 0 0 0-1.51 1.51v12c0 .834.676 1.51 1.51 1.51h13a1.51 1.51 0 0 0 1.51-1.51v-12a1.51 1.51 0 0 0-1.51-1.51",
  fill: "#252525"
}), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  mask: "url(#b)",
  d: "M.486 17.486h17v-17h-17z"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 1.5,
  transform: "translate(4 9)",
  fill: "#6467EF",
  stroke: "#6467EF"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarWithDot);
export default ForwardRef;